import Relay from 'react-relay';
import { fromGlobalId } from 'graphql-relay';

const uuidRegex = /[0-9a-fA-F\-]{30,40}/;

function normalizeSnapshotEntityId(id) {
    if (!id) {
        return id;
    }

    if (uuidRegex.test(id)) {
        return id;
    }

    try {
        const globalId = fromGlobalId(id);
        return globalId.id || id;
    } catch (e) {
        return id;
    }
}

export default {
    testInvocation: (Component, variables) => {
        if (variables && variables.id) {
            variables.id = normalizeSnapshotEntityId(variables.id);
        }

        return Relay.QL`
        query {
            testInvocation(id: $id) {
                ${Component.getFragment('testInvocation', variables)}
            }
        }
    `;
    },
};
